import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from 'react-redux';
import { apiSlice } from "../data/api/api";
import bestAvailableModelSlice from "../data/slices/best-available-model-slice";
import bestAvailableTextSlice from "../data/slices/best-available-text-slice";
import loadingSlice from "../data/slices/loading-slice";
import miniCartModelSlice from "../data/slices/mini-cart-slicer";
import pageIdSlice from "../data/slices/page-id-slicer";

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        bestAvailableText: bestAvailableTextSlice.reducer,
        bestAvailableModel: bestAvailableModelSlice.reducer,
        pageId: pageIdSlice.reducer,
        miniCartModel: miniCartModelSlice.reducer,
        loading: loadingSlice.reducer
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat([
            apiSlice.middleware
        ]);
    }
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;